var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotification = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1674 2.90496C10.1674 1.3006 11.468 0 13.0723 0C14.6767 0 15.9773 1.3006 15.9773 2.90496C15.9773 4.50933 14.6767 5.80993 13.0723 5.80993C11.468 5.80993 10.1674 4.50933 10.1674 2.90496ZM11.6198 2.90496C11.6198 3.70715 12.2701 4.35745 13.0723 4.35745C13.8745 4.35745 14.5248 3.70715 14.5248 2.90496C14.5248 2.10278 13.8745 1.45248 13.0723 1.45248C12.2701 1.45248 11.6198 2.10278 11.6198 2.90496Z",
    fill: "#4A4A4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0723 7.2624C12.6712 7.2624 12.3461 7.58755 12.3461 7.98864V14.5248H1.45248V3.63119H7.98865C8.38974 3.63119 8.71489 3.30604 8.71489 2.90495C8.71489 2.50386 8.38974 2.17871 7.98865 2.17871H0.726241C0.325149 2.17871 0 2.50386 0 2.90495V15.2511C0 15.6521 0.325149 15.9773 0.726241 15.9773H13.0723C13.4734 15.9773 13.7986 15.6521 13.7986 15.2511V7.98864C13.7986 7.58755 13.4734 7.2624 13.0723 7.2624Z",
    fill: "#4A4A4A"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/notification.ac0f7cbfa9bdacdc1cb6426317555042.svg";